#content-wrapper {
  display: flex;
  flex-direction: column;
}

gz-loader {
  --loader-padding-bottom: var(--spacer);
}

.loading-container {
  display: flex;
  flex-direction: column;
  gap: calc(var(--spacer) * 7);

  .loading-header {
    padding: var(--spacer) 0;
    gap: calc(var(--spacer) * 3);

    gz-loader {
      height: fit-content;
    }
  }
}

.loading-header,
.header {
  display: flex;
  align-items: center;
  height: calc(var(--spacer) * 9);
  width: 100%;

  gz-widget-header-item {
    flex: 1;
  }

  .vertical-bar {
    background-color: var(--chart-101-pressed-dividers);
    width: 1px;
    height: 100%;
    margin: calc(var(--spacer) * 1.5);
  }
}

.header {
  padding: var(--spacer) 0;
}

.section {
  display: flex;
  flex-direction: column;
  padding-top: calc(var(--spacer) * 3);
  position: relative;

  .items {
    position: relative;

    .status-message {
      width: 70%;
      margin-left: auto;
      margin-right: auto;
      .status-message-info {
        display: flex;
        .status-message-text-button {
          padding-left: calc(var(--spacer));
          .status-text-div {
            display: flex;
            flex-direction: column;
            .second-text-tooltip {
              .second-text {
                white-space: normal;
              }
            }
          }
        }
      }
    }
  }

  .items gz-risk-overview-section-item:not(:nth-last-child(2)) {
    border-bottom: 1px solid var(--chart-101-pressed-dividers);
  }
}

.section-title {
  display: inline;
  line-height: calc(var(--spacer) * 4);
  cursor: default;
}

.section-title {
  text-transform: uppercase;
  font-weight: 600;
  color: var(--chart-300-icon-buttons);
}

.changed-info-box {
  position: relative;

  > * {
    position: absolute;
    background-color: var(--white-layout-302-level-1-elevation);
    z-index: 1;
  }
}
